import { useState, useEffect } from 'react'
import { fetchFeaturedGuides } from '_/services/destinations/featured-guides/featured-guides'
import { fetchGuidesData } from '_/services/trips/guides/guides'
import { GuidesResponse } from '_/services/destinations/featured-guides/types'

interface UseFetchGuidesParams {
	tripSlug: string
}

export const useFetchGuides = ({ tripSlug }: UseFetchGuidesParams) => {
	const [guidesList, setGuidesList] = useState<GuidesResponse[]>([])
	const [loading, setLoading] = useState<boolean>(true)
	const [error, setError] = useState<Error | null>(null)

	useEffect(() => {
		const fetchGuides = async () => {
			try {
				const [featuredGuidesResponse, guidesResponse] = await Promise.all([
					fetchFeaturedGuides({ slug: tripSlug }),
					fetchGuidesData({ page: 1, pageSize: 4, destinationSlug: tripSlug }),
				])

				const featuredGuides = featuredGuidesResponse.data as GuidesResponse[]
				const guides = guidesResponse.data as GuidesResponse[]

				if (featuredGuides.length < 4) {
					const neededGuides = 4 - featuredGuides.length
					const existingSlugs = new Set(featuredGuides.map(guide => guide.attributes.friendly_slug))

					const additionalGuides = guides
						.filter(guide => !existingSlugs.has(guide.attributes.friendly_slug))
						.slice(0, neededGuides)

					featuredGuides.push(...additionalGuides)
				}

				setGuidesList(featuredGuides.slice(0, 4))
			} catch (err) {
				setError(err as Error)
			} finally {
				setLoading(false)
			}
		}

		fetchGuides()
	}, [tripSlug])

	return { guidesList, loading, error }
}
